import { useMemo } from 'react';

import { useNavigationQuery } from '../../api/portalGateway/navigation';
import { NO_ROLE_ID } from '../../api/portalGatewayClient';
import { useStore } from '../../store';
import { pageWithRoleLink } from '../../utils/urlPath';

export const useGetStaticNavData = () => {
  const roleId = useStore((state) => state.activeUserRole?.id);
  const { data, isPending } = useNavigationQuery();

  return useMemo(() => {
    if (!data?.rootNavigationItems) {
      return { initialPageSlug: null, navItems: [], isPending };
    }

    const navItems = data.rootNavigationItems.map((item) => ({
      href: pageWithRoleLink(roleId ?? NO_ROLE_ID, {
        slug:
          item.type === 'navigation-menu-item'
            ? item.pageSlug
            : item.completeSlug,
      }),
      iconName: item.icon ?? 'draft',
      label: item.label,
      completeSlug: item.slug,
    }));

    return {
      initialPageSlug: data.initialPageSlug,
      navItems,
      isPending,
    };
  }, [data, roleId, isPending]);
};
